module.exports = __webpack_public_path__ + "img/banner-big.16e8ed81.jpg";